
var $window = $(window)

//------------------------------------------------------------------------------
// BODY FADE IN/OUT ON LOAD
//------------------------------------------------------------------------------

$(document).ready(function() {
	$(function() {
    	$('body').removeClass('fade-out');
	});
});

//------------------------------------------------------------------------------
// AUTOMATICALLY UPDATE THE COPYRIGHT YEAR
//------------------------------------------------------------------------------

$(document).ready(function() {
	$(function() {
		var theDate = new Date();
		var theYear = theDate.getFullYear();
    	$('#copyright-year').text(theYear);
	});
});



//------------------------------------------------------------------------------
// MOBILE CHECK
//------------------------------------------------------------------------------

window.mobilecheck = function() {
	var check = false;
	(function(a) {if(/(android|bb\d+|meego).+mobile|android|ipad|playbook|silk|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4)))check = true})(navigator.userAgent||navigator.vendor||window.opera);
	return check;
}
if (window.mobilecheck() == true) {
	// adjustments
}

//------------------------------------------------------------------------------
// ACCORDIAN
//------------------------------------------------------------------------------

$(document).ready(function() {
	$('.ui-acc-container h2').removeAttr('style'); //shopfiy
	$('.ui-acc-container p').removeAttr('style'); // shopfiy
	$('.ui-acc-container span').removeAttr('style'); //shopfiy
	$('.ui-acc-container p').hide()
	if ($('.ui-acc-container').hasClass('first-active') == true) { // show the first accordian element
		$('h2+p').first().show() 
		$('h2 span').first().addClass('is-active')
	}
	$('.ui-acc-container h2').last().addClass('last');
});

$(document).ready(function() {
	$('.ui-acc-container h2 span').click(function(e) {
		e.preventDefault(); // prevents clicking resulting in text selection
		$(this).parent().nextUntil('h2').slideToggle('fast', function() {
			// nil calbacks
	    });
		($(this).hasClass('is-active') === true) ? $(this).removeClass('is-active') : $(this).addClass('is-active');
		($(this).parent().hasClass('is-active') === true) ? $(this).parent().removeClass('is-active') : $(this).parent().addClass('is-active');
	});
});

//------------------------------------------------------------------------------
// REDIRECT
//------------------------------------------------------------------------------

// ipstack does not support https encryption on free plan.

// $(document).ready(function() {
// 	$.ajax({
// 		url: "http://api.ipstack.com/check?access_key=" + access_key,
// 		jsonp: "callback",
// 		dataType: "jsonp"
// 	})
// 	.done(function(data) {
// 		console.log(data);
// 	})
// });

// $('#bag-buttons').hide()
// $('a#bag').hide()
$('#inskin-cta').hide()

//------------------------------------------------------------------------------
// BURGER
//------------------------------------------------------------------------------

$(document).ready(function() {
	$('#burg').click(function(e) {
		e.preventDefault();
		($('.ui-burg').hasClass('is-active') === true) ? $('.ui-burg').removeClass('is-active') : $('.ui-burg').addClass('is-active');
		($('#navbar-wrapper').hasClass('navbar-menu') === true) ? $('#navbar-wrapper').removeClass('navbar-menu') : $('#navbar-wrapper').addClass('navbar-menu');
		($('#navbar-menu-container').hasClass('is-active') === true) ? $('#navbar-menu-container').removeClass('is-active') : $('#navbar-menu-container').addClass('is-active');
		
		if ($('#navbar-wrapper').hasClass('navbar-menu') === true) {
			$('html').css('overflow','hidden') // Prevent scrolling when modal menu is open.
			$('body').bind('touchmove', function(e) { // Prevent scrolling when modal menu is open - mobile.
	            e.preventDefault()
	        });
		}
		else {
			$('html').css('overflow', 'scroll');
	        $('body').unbind('touchmove');
		}
	});
});

//------------------------------------------------------------------------------
// ON SCROLL EVENTS
//------------------------------------------------------------------------------

$window.scroll(function() {
	if ($window.scrollTop() <= 72) {
		$('#navbar-wrapper').addClass("navbar-top");
		$('#navbar-wrapper').removeClass("navbar-body");
		$('#navbar-spacer').removeClass("navbar-body");
		$('#navbar-box-4 .navbar-item').show();
		$('.eb-mark-side').hide();
	}
	else {
		$('#navbar-wrapper').removeClass("navbar-top");
		$('#navbar-wrapper').addClass("navbar-body");
		$('#navbar-spacer').addClass("navbar-body");
		$('#navbar-box-4 .navbar-item').hide();
		$('.eb-mark-side').show();
	}
});

//------------------------------------------------------------------------------
// SWIPER
//------------------------------------------------------------------------------

$(document).ready(function() {
	var mySwiper = new Swiper ('.swiper-container', {
		pagination: '.swiper-pagination',
		paginationClickable: true,
		effect: 'fade',
		fade: {
  			crossFade: true
		},
		//nextButton: '.swiper-button-next',
		//prevButton: '.swiper-button-prev',
		grabCursor: false,
		autoplay: 5000,
		virtualTranslate: true, //crossfade
		speed: 1000, //crossfade
		loop: true
	})        
});

//------------------------------------------------------------------------------
// FORMAT PAGE
//------------------------------------------------------------------------------

$("#pagel3-wrapper h2").each(function() {
	$(this).nextUntil("h2, hr").andSelf().wrapAll("<div class='pagel3-text-block-container'></div>");
});

//------------------------------------------------------------------------------
// EMAIL SUBSCRIPTION FORM
//------------------------------------------------------------------------------

$(document).ready(function() {
	$("form#email_form").attr("onsubmit","return validateSubscriptionForm()");
});
function validateSubscriptionForm () {
	$('mce-EMAIL').removeClass('form-validate-error')
	fm = document.getElementById('email_form')
	var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	var em = re.test(fm["EMAIL"].value)
	if (em == false) {
		new Snackbar('Please check your email address and try again.', {timeout: 8000});
		$('#mce-EMAIL').addClass('form-validate-error')
		return false;
	}
}

//------------------------------------------------------------------------------
// CONTACT
//------------------------------------------------------------------------------

// Contact form validation.
$("form#contact_form").attr("onsubmit","return validateContactForm()");
function validateContactForm () {
	$('.form-input').removeClass('form-validate-error')
	fm = document.getElementById('contact_form')
    var nm = fm["contact[name]"].value;
    var ms = fm["contact[body]"].value;
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    var em = re.test(fm["contact[email]"].value)
    if (nm == null || nm == "") {
        new Snackbar('Please include your name.', {timeout: 8000});
        $('#contactFormName').addClass('form-validate-error')
        return false;
    }
    if (ms == null || ms == "") {
        new Snackbar('Please include your message.', {timeout: 8000});
        $('#contactFormMessage').addClass('form-validate-error')
        return false;
    }
    if (em == false) {
        new Snackbar('Please include a valid email address so that we can reply to you.', {timeout: 8000});
        $('#contactFormEmail').addClass('form-validate-error')
        return false;
    }
};

// Direct email.
var emailer = {
	sendEmail: function(target) {
		window.location.href = "mailto:" + target + "@eightbrook.com"
	}
};

//------------------------------------------------------------------------------
// INDEX PAGE - BUY NOW
//------------------------------------------------------------------------------

$("#featured-buy").click(function(e) {
	e.preventDefault();
	var itemId = $(this).attr('productid')
	var itemQuantity = 1;
	$(this).text("Working...")
	CartJS.addItem(itemId, itemQuantity, {}, {
		"success": function(data, textStatus, jqXHR) {
			jQuery.getJSON('/cart.js', function(cart) {
				if (cart.item_count == 0) {
					// location.reload();
				}
			});
			window.location.assign("/checkout")
		},
		"error": function(jqXHR, textStatus, errorThrown) {
			alert('Unfortunately an error has occurred. Please refresh this page and try again. If that doesn\'t work, please contact us');
		}
	});
});

//------------------------------------------------------------------------------
// CART PAGE
//------------------------------------------------------------------------------

// Initialise CartJS

// Cart update item quanity field
$(".cart-quantity-input").change(function() {
	var itemId = $(this).attr('id')
	var itemProductHandle = $(this).attr('product')
	var itemQuantitySelector = "#" + itemId + ".cart-quantity-input"
	var itemQuantity = $(itemQuantitySelector).val();
	if (itemQuantity > 0) {
		cartScreenItemQuantity(itemId, itemQuantity, itemProductHandle, itemQuantitySelector, cartUpdateItemQuantity)
	}
	else {
		cartRemoveItem(itemId)
	}
});

// Cart screen values to determine compare SOH with selected quantity
function cartScreenItemQuantity(itemId, itemQuantity, itemProductHandle, itemQuantitySelector, callback) {
	jQuery.getJSON('/products/' + itemProductHandle + '.js', function(product) { // Check that the updated quantity doesn't exceed inventory
		var productSOH = product.variants[0].inventory_quantity
		if (parseInt(itemQuantity) <= parseInt(productSOH)) {
			callback(itemId, itemQuantity)
		}
		else {
			var verb1 = "are"
			var verb2 = "s"
			var verb3 = "these"
			if (productSOH == 1 ) {
				verb1 = "is"
				verb2 = ""
				verb3 = "this"
			}
			new Snackbar('There ' + verb1 + ' ' + productSOH + ' unit' + verb2 + ' of this product in stock. We have placed ' + verb3 + ' in your bag.', {timeout: 8000});
			$(itemQuantitySelector).val(productSOH)
			callback(itemId, productSOH)
		}
	});
}

// Cart update Item
function cartUpdateItemQuantity(itemId, itemQuantity) {
	cartUpdateDOMWaiting(itemId);
	CartJS.updateItemById(itemId, itemQuantity, {}, {
		"success": function(data, textStatus, jqXHR) {
			jQuery.getJSON('/cart.js', function(cart) {
				if (cart.item_count == 0) {
					location.reload();
				}
			});
			cartUpdateDOMComplete(itemId);
		},
		"error": function(jqXHR, textStatus, errorThrown) {
			alert('Unfortunately an error has occurred. Please refresh this page and try again. If that doesn\'t work, please contact us');
		}
	});
}

// Cart DOM Update - Waiting
function cartUpdateDOMWaiting(itemId) {
	itemLinePriceSelector = "#" + itemId + ".cart-item-total-data";
	$(itemLinePriceSelector).html("-")
	$('.cart-total-price').html("-");
	$('sup#bag-count').html("-")
}

// Cart DOM Update - Complete
function cartUpdateDOMComplete(itemId) {
	itemLinePriceSelector = "#" + itemId + ".cart-item-total-data";
	jQuery.getJSON('/cart.js', function(cart) {
		for (var i=0; i<= cart.items.length-1; i++) {
			if (cart.items[i].id == itemId) {
				var linePrice = convertShopifyAmountToCurrency(cart.items[i].line_price, false)
				$(itemLinePriceSelector).html(linePrice)
			}
		}
		totalPrice = convertShopifyAmountToCurrency(cart.total_price)
		$('.cart-total-price').html(totalPrice);
		if (cart.item_count == 0) {
			$('sup#bag-count').html("")
		}
		else {
			$('sup#bag-count').html(cart.item_count)
		}
	});
}

// Cart remove item - click
$('.cart-item-remove-lg, .cart-item-remove-sm').click(function(e) {
	e.preventDefault();
	itemId = $(this).attr("id");
	cartRemoveItem($(this).attr("id"));
});

// Cart remove item
function cartRemoveItem(itemId) {
	$("#" + itemId + ".cart-item").hide('slow', function(){ 
		$("#" + itemId + ".cart-item").remove();
		cartUpdateItemQuantity(itemId, 0)
	});
}

// Cart checkout button
$('.cart-checkout-button').click(function(e) {
	e.preventDefault();
	window.location.assign("/checkout")
});

// Currency Format - Shopify provides the full amount, including cents, without a decimal.
function convertShopifyAmountToCurrency(shopifyAmount, withCents) {
	var itemLinePriceString = shopifyAmount.toString();
	var itemLinePriceStringDollars = itemLinePriceString.slice(0, -2);
	var itemLinePriceStringCents = itemLinePriceString.slice(-2);
	if (withCents == true) {
		return "$" + itemLinePriceStringDollars + "." + itemLinePriceStringCents;
	}
	else {
		return "$" + itemLinePriceStringDollars;
	}
}